export default "__VITE_ASSET__BNlMuECY__"